import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  // machines
  listMachines: () => axios.get(`${API}/machines`).then((r) => r.data),
  getMachine: (id) => axios.get(`${API}/machines/${id}`).then((r) => r.data),
  machineAction: (id, action, operator, extra = {}) =>
    axios.post(`${API}/machines/${id}/action`, { action, operator, ...extra }).then((r) => r.data),
  createMachine: (payload) => axios.post(`${API}/machines`, payload).then((r) => r.data),
  updateMachine: (id, payload) => axios.put(`${API}/machines/${id}`, payload).then((r) => r.data),
  deleteMachine: (id) => axios.delete(`${API}/machines/${id}`).then((r) => r.data),

  // logs & problems
  listLogs: () => axios.get(`${API}/logs`).then((r) => r.data),
  deleteLog: (id) => axios.delete(`${API}/logs/${id}`).then((r) => r.data),
  resetLogs: () => axios.delete(`${API}/logs`).then((r) => r.data),
  restoreLogs: (token) => axios.post(`${API}/logs/restore`, { token }).then((r) => r.data),
  listProblems: () => axios.get(`${API}/problems`).then((r) => r.data),
  deleteProblem: (id) => axios.delete(`${API}/problems/${id}`).then((r) => r.data),
  resetProblems: () => axios.delete(`${API}/problems`).then((r) => r.data),
  restoreProblems: (token) => axios.post(`${API}/problems/restore`, { token }).then((r) => r.data),
  updateProblem: (id, status) => axios.patch(`${API}/problems/${id}`, { status }).then((r) => r.data),

  // problem presets / recent reasons + translation
  listProblemPresets: () => axios.get(`${API}/problem-presets`).then((r) => r.data),
  createProblemPreset: (payload) => axios.post(`${API}/problem-presets`, payload).then((r) => r.data),
  bulkCreatePresets: (items) => axios.post(`${API}/problem-presets/bulk`, { items }).then((r) => r.data),
  deleteProblemPreset: (id) => axios.delete(`${API}/problem-presets/${id}`).then((r) => r.data),
  translateText: (text, source) => axios.post(`${API}/translate`, { text, source }).then((r) => r.data),

  // reject causes (editable pick-list)
  listRejectCauses: () => axios.get(`${API}/reject-causes`).then((r) => r.data),
  createRejectCause: (name) => axios.post(`${API}/reject-causes`, { name }).then((r) => r.data),
  deleteRejectCause: (id) => axios.delete(`${API}/reject-causes/${id}`).then((r) => r.data),

  // setting reasons (editable pick-list of common changeover reasons)
  listSettingReasons: () => axios.get(`${API}/setting-reasons`).then((r) => r.data),
  createSettingReason: (name) => axios.post(`${API}/setting-reasons`, { name }).then((r) => r.data),
  deleteSettingReason: (id) => axios.delete(`${API}/setting-reasons/${id}`).then((r) => r.data),

  // machine types (editable category pick-list)
  listMachineTypes: () => axios.get(`${API}/machine-types`).then((r) => r.data),
  createMachineType: (name) => axios.post(`${API}/machine-types`, { name }).then((r) => r.data),
  deleteMachineType: (id) => axios.delete(`${API}/machine-types/${id}`).then((r) => r.data),

  // materials
  listMaterials: () => axios.get(`${API}/materials`).then((r) => r.data),
  createMaterial: (payload) => axios.post(`${API}/materials`, payload).then((r) => r.data),
  updateMaterial: (code, payload) => axios.put(`${API}/materials/${code}`, payload).then((r) => r.data),
  deleteMaterial: (code) => axios.delete(`${API}/materials/${code}`).then((r) => r.data),
  adjustMaterial: (code, delta, note, machine) => axios.post(`${API}/materials/${code}/adjust`, { delta, note, machine }).then((r) => r.data),
  materialUsage: (code) => axios.get(`${API}/materials/${code}/usage`).then((r) => r.data),
  allMaterialUsage: () => axios.get(`${API}/material-usage`).then((r) => r.data),

  // assignments
  listAssignments: () => axios.get(`${API}/assignments`).then((r) => r.data),
  createAssignment: (payload) => axios.post(`${API}/assignments`, payload).then((r) => r.data),
  updateAssignment: (id, payload) => axios.put(`${API}/assignments/${id}`, payload).then((r) => r.data),
  deleteAssignment: (id) => axios.delete(`${API}/assignments/${id}`).then((r) => r.data),

  // analytics
  fleetAnalytics: (machine, rq) => axios.get(`${API}/analytics/fleet`, { params: { ...(machine ? { machine } : {}), ...(rq || {}) } }).then((r) => r.data),
  productionAnalytics: (machine, rq) => axios.get(`${API}/analytics/production`, { params: { ...(machine ? { machine } : {}), ...(rq || {}) } }).then((r) => r.data),
  materialConsumption: (days = 14, machine, rq) => axios.get(`${API}/analytics/material-consumption`, { params: { days, ...(machine ? { machine } : {}), ...(rq || {}) } }).then((r) => r.data),
  problemReport: (month, machine) => axios.get(`${API}/analytics/problem-report`, { params: { ...(month ? { month } : {}), ...(machine ? { machine } : {}) } }).then((r) => r.data),
  problemReportAI: (month, machine) => axios.post(`${API}/analytics/problem-report/ai`, null, { params: { ...(month ? { month } : {}), ...(machine ? { machine } : {}) } }).then((r) => r.data),
  problemTrend: (months = 6) => axios.get(`${API}/analytics/problem-trend`, { params: { months } }).then((r) => r.data),

  // jobs (production scheduling)
  listJobs: () => axios.get(`${API}/jobs`).then((r) => r.data),
  createJob: (payload) => axios.post(`${API}/jobs`, payload).then((r) => r.data),
  updateJob: (code, payload) => axios.put(`${API}/jobs/${code}`, payload).then((r) => r.data),
  deleteJob: (code) => axios.delete(`${API}/jobs/${code}`).then((r) => r.data),

  // shift settings
  getShifts: () => axios.get(`${API}/settings/shifts`).then((r) => r.data),
  saveShifts: (shifts) => axios.put(`${API}/settings/shifts`, { shifts }).then((r) => r.data),
  resetAppData: () => axios.post(`${API}/admin/reset-data`, {}).then((r) => r.data),
  changePassword: (current_password, new_password) => axios.post(`${API}/auth/change-password`, { current_password, new_password }).then((r) => r.data),

  // material schedule
  listMatSchedule: () => axios.get(`${API}/material-schedule`).then((r) => r.data),
  createMatSchedule: (payload) => axios.post(`${API}/material-schedule`, payload).then((r) => r.data),
  updateMatSchedule: (id, payload) => axios.put(`${API}/material-schedule/${id}`, payload).then((r) => r.data),
  deleteMatSchedule: (id) => axios.delete(`${API}/material-schedule/${id}`).then((r) => r.data),
  approveMatSchedule: (id) => axios.post(`${API}/material-schedule/${id}/approve`).then((r) => r.data),

  // shift coverage analytics
  shiftCoverage: () => axios.get(`${API}/analytics/shift-coverage`).then((r) => r.data),
  settingReport: (month, machine, period, reason, rq) => axios.get(`${API}/analytics/setting-report`, { params: { ...(month ? { month } : {}), ...(machine ? { machine } : {}), ...(period ? { period } : {}), ...(reason ? { reason } : {}), ...(rq || {}) } }).then((r) => r.data),
  operatorPerformance: (period) => axios.get(`${API}/analytics/operator-performance`, { params: { ...(period ? { period } : {}) } }).then((r) => r.data),
  shiftSummary: (operator) => axios.get(`${API}/operator/shift-summary`, { params: { ...(operator ? { operator } : {}) } }).then((r) => r.data),
  performanceTrend: (operator, months) => axios.get(`${API}/analytics/performance-trend`, { params: { ...(operator ? { operator } : {}), ...(months ? { months } : {}) } }).then((r) => r.data),
  settingTrend: (months = 6, machine) => axios.get(`${API}/analytics/setting-trend`, { params: { months, ...(machine ? { machine } : {}) } }).then((r) => r.data),
  settingAlerts: () => axios.get(`${API}/analytics/setting-alerts`).then((r) => r.data),
  operatorBadges: (operator) => axios.get(`${API}/analytics/operator-badges`, { params: { ...(operator ? { operator } : {}) } }).then((r) => r.data),
  listAwards: (operator) => axios.get(`${API}/awards`, { params: { ...(operator ? { operator } : {}) } }).then((r) => r.data),
  createAward: (payload) => axios.post(`${API}/awards`, payload).then((r) => r.data),
  deleteAward: (id) => axios.delete(`${API}/awards/${id}`).then((r) => r.data),
  awardsLeaderboard: () => axios.get(`${API}/analytics/awards-leaderboard`).then((r) => r.data),
  getVapidKey: () => axios.get(`${API}/push/vapid-public-key`).then((r) => r.data),
  pushSubscribe: (payload) => axios.post(`${API}/push/subscribe`, payload).then((r) => r.data),
  pushPrefs: (payload) => axios.post(`${API}/push/prefs`, payload).then((r) => r.data),
  getMyShift: () => axios.get(`${API}/push/my-shift`).then((r) => r.data),
  pushTest: () => axios.post(`${API}/push/test`).then((r) => r.data),
  pushUnsubscribe: (payload) => axios.post(`${API}/push/unsubscribe`, payload).then((r) => r.data),
  getChangeoverTarget: () => axios.get(`${API}/settings/changeover-target`).then((r) => r.data),
  setChangeoverTarget: (target) => axios.put(`${API}/settings/changeover-target`, { target }).then((r) => r.data),
  getMaterialSettingConfig: () => axios.get(`${API}/settings/material-setting`).then((r) => r.data),
  setMaterialSettingConfig: (cfg) => axios.put(`${API}/settings/material-setting`, cfg).then((r) => r.data),

  // low-stock reorder
  reorderMaterial: (code) => axios.post(`${API}/materials/${code}/reorder`).then((r) => r.data),

  // audit trail
  listAudit: (entity_type, entity_id) => {
    const params = {};
    if (entity_type) params.entity_type = entity_type;
    if (entity_id) params.entity_id = entity_id;
    return axios.get(`${API}/audit`, { params }).then((r) => r.data);
  },
  sendAuditReport: () => axios.post(`${API}/admin/send-audit-report`, {}).then((r) => r.data),

  // auto-reorder rule
  getAutoReorder: () => axios.get(`${API}/settings/auto-reorder`).then((r) => r.data),
  setAutoReorder: (enabled) => axios.put(`${API}/settings/auto-reorder`, { enabled }).then((r) => r.data),
  getPreferences: () => axios.get(`${API}/settings/preferences`).then((r) => r.data),
  setPreferences: (payload) => axios.put(`${API}/settings/preferences`, payload).then((r) => r.data),

  // auth
  forgotPassword: (email) => axios.post(`${API}/auth/forgot-password`, { email }).then((r) => r.data),
  resetPassword: (token, new_password) => axios.post(`${API}/auth/reset-password`, { token, new_password }).then((r) => r.data),
  setLanguage: (lang) => axios.put(`${API}/auth/language`, { lang }).then((r) => r.data),

  // users management
  listUsers: () => axios.get(`${API}/users`).then((r) => r.data),
  createUser: (payload) => axios.post(`${API}/users`, payload).then((r) => r.data),
  updateUser: (id, payload) => axios.put(`${API}/users/${id}`, payload).then((r) => r.data),
  deleteUser: (id) => axios.delete(`${API}/users/${id}`).then((r) => r.data),
  // warehouses
  listWarehouses: () => axios.get(`${API}/warehouses`).then((r) => r.data),
  createWarehouse: (payload) => axios.post(`${API}/warehouses`, payload).then((r) => r.data),
  updateWarehouse: (id, payload) => axios.put(`${API}/warehouses/${id}`, payload).then((r) => r.data),
  deleteWarehouse: (id) => axios.delete(`${API}/warehouses/${id}`).then((r) => r.data),
  moveMachine: (machine_id, target_warehouse_id) => axios.post(`${API}/warehouses/move-machine`, { machine_id, target_warehouse_id }).then((r) => r.data),
  moveMachines: (machine_ids, target_warehouse_id) => axios.post(`${API}/warehouses/move-machines`, { machine_ids, target_warehouse_id }).then((r) => r.data),
  movePreflight: (machine_ids) => axios.post(`${API}/warehouses/move-preflight`, { machine_ids }).then((r) => r.data),
  warehousesOverview: () => axios.get(`${API}/warehouses/overview`).then((r) => r.data),
};

export default api;
